import React, { useState } from 'react';
import { Shield, Award, CheckCircle, X } from 'lucide-react';
import { diplomaSpa, diplomaAyurveda, govReg } from '../assets/images';

const TrustSection = () => {
    const [lightboxImage, setLightboxImage] = useState(null);

    return (
        <section id="credentials" className="py-20 bg-gradient-to-b from-cream to-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <div className="text-center mb-16 animate-fade-in">
                    <div className="inline-flex items-center bg-zen-gold/10 px-6 py-2 rounded-full mb-4">
                        <Shield className="text-zen-gold mr-2" size={24} />
                        <span className="text-coffee-900 font-semibold">100% Verified & Genuine</span>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-display font-bold text-coffee-900 mb-4">
                        Professional Credentials
                    </h2>
                    <p className="text-lg text-coffee-700 max-w-2xl mx-auto">
                        Government Registered & Certified Therapist with Official Documentation
                    </p>
                </div>

                {/* Trust Badges */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
                    <div className="premium-card bg-white p-6 rounded-2xl shadow-premium text-center">
                        <div className="bg-zen-gold/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <Award className="text-zen-gold" size={32} />
                        </div>
                        <h3 className="text-xl font-display font-bold text-coffee-900 mb-2">
                            Professional Diploma
                        </h3>
                        <p className="text-coffee-700">
                            Ayurveda & Panchakarma Therapy (2007)
                        </p>
                    </div>

                    <div className="premium-card bg-white p-6 rounded-2xl shadow-premium text-center">
                        <div className="bg-zen-gold/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <Shield className="text-zen-gold" size={32} />
                        </div>
                        <h3 className="text-xl font-display font-bold text-coffee-900 mb-2">
                            Government Registered
                        </h3>
                        <p className="text-coffee-700">
                            Karnataka Labour Department (2018)
                        </p>
                    </div>

                    <div className="premium-card bg-white p-6 rounded-2xl shadow-premium text-center">
                        <div className="bg-zen-gold/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <Award className="text-zen-gold" size={32} />
                        </div>
                        <h3 className="text-xl font-display font-bold text-coffee-900 mb-2">
                            Professional Diploma
                        </h3>
                        <p className="text-coffee-700">
                            Spa & Thai Massage Certification (2010)

                        </p>
                    </div>
                </div>

                {/* Credential Documents - 3 Certificates */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">

                    {/* Diploma in Ayurveda - RIGHT */}
                    <div className="premium-card bg-white p-6 rounded-2xl shadow-premium flex flex-col">
                        <h4 className="text-lg font-display font-bold text-coffee-900 mb-4 text-center">
                            Diploma - Ayurveda & Panchakarma
                        </h4>
                        <div
                            onClick={() => setLightboxImage(diplomaAyurveda)}
                            className="cursor-pointer relative overflow-hidden rounded-xl group flex-grow"
                        >
                            <img
                                src={diplomaAyurveda}
                                alt="Diploma in Ayurveda Massage and Panchakarma Therapy"
                                loading="lazy"
                                decoding="async"
                                width={400}
                                height={500}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-coffee-900/0 group-hover:bg-coffee-900/20 transition-all duration-300 flex items-center justify-center">
                                <span className="text-white opacity-0 group-hover:opacity-100 text-lg font-semibold">
                                    Click to View
                                </span>
                            </div>
                        </div>
                        <p className="text-sm text-coffee-700 mt-3 text-center">
                            ICPEM - First Class (2005-2007)
                        </p>
                    </div>



                    {/* Government Registration - CENTER */}
                    <div className="premium-card bg-white p-6 rounded-2xl shadow-premium flex flex-col">
                        <h4 className="text-lg font-display font-bold text-coffee-900 mb-4 text-center">
                            Government Registration
                        </h4>
                        <div
                            onClick={() => setLightboxImage(govReg)}
                            className="cursor-pointer relative overflow-hidden rounded-xl group flex-grow"
                        >
                            <img
                                src={govReg}
                                alt="Government of Karnataka Registration Certificate"
                                loading="lazy"
                                decoding="async"
                                width={400}
                                height={500}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-coffee-900/0 group-hover:bg-coffee-900/20 transition-all duration-300 flex items-center justify-center">
                                <span className="text-white opacity-0 group-hover:opacity-100 text-lg font-semibold">
                                    Click to View
                                </span>
                            </div>
                        </div>
                        <p className="text-sm text-coffee-700 mt-3 text-center">
                            Karnataka Labour Department (2018)
                        </p>
                    </div>
                    {/* Diploma in Spa & Thai Massage - LEFT */}
                    <div className="premium-card bg-white p-6 rounded-2xl shadow-premium flex flex-col">
                        <h4 className="text-lg font-display font-bold text-coffee-900 mb-4 text-center">
                            Diploma - Spa & Thai Massage
                        </h4>
                        <div
                            onClick={() => setLightboxImage(diplomaSpa)}
                            className="cursor-pointer relative overflow-hidden rounded-xl group flex-grow"
                        >
                            <img
                                src={diplomaSpa}
                                alt="Diploma in Spa & Thai Massage Certificate"
                                loading="lazy"
                                decoding="async"
                                width={400}
                                height={500}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-coffee-900/0 group-hover:bg-coffee-900/20 transition-all duration-300 flex items-center justify-center">
                                <span className="text-white opacity-0 group-hover:opacity-100 text-lg font-semibold">
                                    Click to View
                                </span>
                            </div>
                        </div>
                        <p className="text-sm text-coffee-700 mt-3 text-center">
                            ICPEM - First Class (2008-2010)
                        </p>
                    </div>

                </div>
            </div>

            {/* Lightbox Modal */}
            {
                lightboxImage && (
                    <div
                        onClick={() => setLightboxImage(null)}
                        className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
                    >
                        <button
                            onClick={() => setLightboxImage(null)}
                            className="absolute top-4 right-4 text-white hover:text-zen-gold transition-colors"
                        >
                            <X size={36} />
                        </button>
                        <img
                            src={lightboxImage}
                            alt="Certificate"
                            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                )
            }
        </section >
    );
};

export default TrustSection;
